import FormManager from "../services/form-manager";

require("../polyfills");
require('../utilities');
require("../services/logging-manager");
require("../app/upper-message-bar-cookie");

import EventManager from "../services/event-manager";
import AcousticSignalManager from "../services/acoustic-signal-manager";
import AbstractReactBehaviour from "../behaviours/abstract-react-behaviour";
import LazyLoad from "vanilla-lazyload";
import CookieManager from "../services/cookie-manager";
import CacheManager from "../services/cache-manager";
import DataLayerManager from "../services/datalayer-manager";
import PreRenderManager from "../services/pre-render-manager";


export default class Application  {
    env = null;
    initialized = false;

    events = {
        start: 'app.start',
        reload: 'app.reload',
    }


    constructor(config, enviroment = 'prod') {
        window.app = this;
        this.env = enviroment;
        this.eventManager = new EventManager();
        this.formManager = new FormManager();
        this.cookieManager = new CookieManager();
        this.cacheManager = new CacheManager();
        this.dataLayerManager = new DataLayerManager();
        this.preRenderManager = new PreRenderManager();
        this.acousticSignalManager = new AcousticSignalManager(this.eventManager);


        this.init(config);

        window.app = this;
        window.initApp = this.load; //create initApp to support legacy js.
        document.readyState !== "loading" ? this.load() : document.addEventListener("DOMContentLoaded",  this.load);
    }

    createEvents = () => {
        this.eventManager.createEvent(this.events.start, 'Event fires when the app starts', {
            app:this
        });
        this.eventManager.subscribe(this.events.start, () => {
            console.log('Application Started'); // @ignore
        });

        this.eventManager.createEvent(this.events.reload, 'Event fires when the app is reloaded', {
            app:this
        });
        this.eventManager.subscribe(this.events.reload, this.load);
    }

    registerBehaviors = config => {
        let defaults = {};
        config = Object.assign(defaults, config);

        window.dataAttrBehaviours = config;
    };

    registerReactComponents = config => {
        let defaults = {};
        config = Object.assign(defaults, config);

        class ReactBehaviour extends AbstractReactBehaviour {
            getComponentMap = () => config;
        }

        if(!window.dataAttrBehaviours) window.dataAttrBehaviours = {};
        window.dataAttrBehaviours.ReactBehaviour = new ReactBehaviour();
    };

    registerLazyLoad = config => {
        let defaults = {
            elements_selector: ".lazyload",
            class_loading: "lazyload--loading",
            class_loaded: "lazyload--loaded",
            skip_invisible: false,
            threshold: 500,
        };

        config = Object.assign(defaults, config);
        window.lazy = new LazyLoad(config);
    };

    loadDataAttrBehaviours = behaviours => {
        for (let key in behaviours) {
            behaviours[key].init();
        }
    };

    init = config => {
        let defaults = {
            behaviours: {},
            components: {},
            lazyLoad: {},
            //serviceWorker: {}
        };

        config = Object.assign(defaults, config);

        if(!this.initialized) {
            this.createEvents();
            //this.registerServiceWorker( config.serviceWorker);
            this.registerBehaviors(config.behaviours);
            this.registerReactComponents(config.components);
            this.registerLazyLoad(config.lazyLoad);
            this.acousticSignalManager.registerSubscribers();

            this.initialized = true;
            this.eventManager.triggerEvent('app.start', {
                url: window.location.origin + window.location.pathname,
            });
        }
    };

    load = () => {
        this.loadDataAttrBehaviours( window.dataAttrBehaviours );
        window.lazy.update();
    };

}
